<template>
  <BaseVeeForm :action="handleFormSubmit">
    <template #default="formProps">
      <VModal ref="dialog" :disable-backdrop-click="formProps.isPending" @close="$emit('close')">
        <template #default="modalProps">
          <div class="rounded shadow-xs w-full max-w-lg mx-auto">
            <div class="rounded shadow-lg bg-white">
              <div class="px-4 sm:px-6 py-5 border-b">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <h1 class="text-sm">New Pipeline</h1>
                  </div>

                  <div class="flex-none">
                    <button
                      type="button"
                      class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      @click="modalProps.close"
                    >
                      <span class="sr-only">Close</span>
                      <svg
                        class="inline-flex h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="p-4 sm:p-6 space-y-8">
                <BaseFormTextFieldWithValidator
                  v-model="data.name"
                  v-bind="pipelineNameFieldProps"
                />

                <PipelineTemplateSelectField
                  v-model="data.pipeline_template_id"
                  :account-id="accountId"
                />

                <BaseButton primary> Create </BaseButton>
              </div>
            </div>
          </div>
        </template>
      </VModal>
    </template>
  </BaseVeeForm>
</template>

<script>
import PipelineTemplateSelectField from './PipelineTemplateSelectField.vue';

export default {
  name: 'CreateEmailCampaignDialog',
  components: {
    PipelineTemplateSelectField,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      data: {
        name: '',
        pipeline_template_id: null,
      },
    };
  },
  computed: {
    pipelineNameFieldProps() {
      return {
        validator: {
          name: 'name',
          vid: 'name',
          rules: { required: true },
        },
        field: {
          id: 'pipeline_name',
          label: 'Pipeline name',
        },
      };
    },
  },
  methods: {
    handleFormSubmit() {
      return this.action(this.data).then((response) => {
        this.$refs.dialog.close();
        return Promise.resolve(response);
      });
    },
  },
};
</script>
